import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { loggedUserIdSelector } from '../../redux/context/selectors';

const useGetPrimarySubscriberTitle = ({
  formatMessage,
  targetUserName,
  targetUserId,
}) => {
  const loggedUserId = useSelector(loggedUserIdSelector);

  const isLoggedUser = loggedUserId === targetUserId;

  return useMemo(() => {
    if (isLoggedUser) {
      return formatMessage({ id: 'fields.insurance.mainPrimarySubscriber' });
    }

    return formatMessage(
      { id: 'fields.insurance.primarySubscriber' },
      { name: targetUserName },
    );
  }, [isLoggedUser, targetUserName]);
};

export default useGetPrimarySubscriberTitle;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useGetPrimarySubscriberTitle.js